import Chelia51 from '../Chelia/Chelia 5 2 Lantai (1).webp'
import Chelia52 from '../Chelia/Chelia 5 2 Lantai (2).webp'



const Chelia5images =[
Chelia51,Chelia52
]

export default Chelia5images;